import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import testimonialService from "../../services/testimonial/testimonialService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./Testimonial.css";

export default function TestimonialsList() {

    const [testimonials, setTestimonials] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadTestimonials();
    }, [page, search]);

    const loadTestimonials = async () => {

        try {

            setLoading(true);

            const response = await testimonialService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setTestimonials(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {
            const response = await testimonialService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadTestimonials();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Testimonials</h2>

                <Link
                    to="/testimonials/add"
                    className="btn btn-primary"
                >
                    Add Testimonials
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search testimonials..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>
                                <th>Photo</th>
                                <th>Customer</th>

                                <th>Company</th>

                                <th>Designation</th>

                                <th>Rating</th>

                                <th>Status</th>

                                <th width="170">Action</th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    testimonials.length === 0 ?

                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No testimonials Found
                                            </td>
                                        </tr>

                                        :

                                        testimonials.map(item => (

                                            <tr key={item.testimonialId}>
                                                <td>
                                                    {
                                                        item.photo &&
                                                        <img
                                                            src={`${process.env.REACT_APP_SERVER_URL}${item.photo}`}
                                                            alt={item.customerName}
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                objectFit: "cover",
                                                                borderRadius: "6px"
                                                            }}
                                                        />
                                                    }
                                                </td>
                                                <td>{item.customerName}</td>

                                                <td>{item.companyName}</td>

                                                <td>{item.designation}</td>

                                                <td>
                                                    {item.rating} ⭐
                                                </td>

                                                <td>
                                                    {
                                                        item.isActive
                                                            ? <span className="badge bg-success">Active</span>
                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }
                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/testimonials/edit/${item.testimonialId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.testimonialId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}